import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useAuth } from '../../contexts/AuthContext';
import { getApiUrl } from '../../config';

// Avatar images
import adminAvatar1 from '../../assets/images/users/avatar-2.jpg'; // Sarah
import adminAvatar2 from '../../assets/images/users/avatar-3.jpg'; // James
import defaultAvatar from '../../assets/images/users/default-avatar.svg';

const ProfileDropdown = () => {
    const { user } = useAuth();

    // Get display values from user context
    // Support both full_name and first_name/last_name combinations
    const userName = user?.full_name ||
        (user?.first_name && user?.last_name ? `${user.first_name} ${user.last_name}` : null) ||
        user?.first_name ||
        user?.username ||
        user?.email?.split('@')[0] ||
        "User";
    const jobTitle = user?.job_title || "";

    // Handle avatar URL - use imported images for admin users
    const getAvatarSrc = () => {
        const avatarUrl = user?.avatar_url;
        if (!avatarUrl) return defaultAvatar;

        // Check if it's an admin avatar path and use imported image
        if (avatarUrl.includes('avatar-2.jpg')) return adminAvatar1;
        if (avatarUrl.includes('avatar-3.jpg')) return adminAvatar2;

        // For external URLs, use as-is
        if (avatarUrl.startsWith('http')) return avatarUrl;

        // For API-served files
        return getApiUrl(avatarUrl);
    };
    const avatarSrc = getAvatarSrc();

    // Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <img
                            className="rounded-circle header-profile-user"
                            src={avatarSrc}
                            alt="Avatar"
                            style={{ width: '32px', height: '32px', objectFit: 'cover' }}
                        />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{userName}</span>
                            {jobTitle && (
                                <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                                    {jobTitle}
                                </span>
                            )}
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {userName}!</h6>
                    <DropdownItem className='p-0'>
                        <Link to="/pages-profile-settings" className="dropdown-item">
                            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Profile</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to="/apps-ecommerce-orders" className="dropdown-item">
                            <i className="mdi mdi-shopping text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">My Orders</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to="/apps-ecommerce-products" className="dropdown-item">
                            <i className="mdi mdi-store text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">My Products</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to="/pages-faqs" className="dropdown-item">
                            <i className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Help</span>
                        </Link>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem className='p-0'>
                        <Link to="/pages-profile-settings" className="dropdown-item">
                            <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle">Settings</span>
                        </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                        <Link to="/logout" className="dropdown-item">
                            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
                            <span className="align-middle" data-key="t-logout">Logout</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;
